module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "spart",
    attrs: {
      "epub:type": "division",
      "id": "spart-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_c('div', {
    staticClass: "spart_debut"
  }), _c('div', {
    staticClass: "dev"
  }, [_c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig-003"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "The lighthouse top at Watchet Harbour: the beacon of vision, the light of reason, and a lifelong delight in philosophy.",
      "src": "images/pg_14_Lighthouse.jpg"
    }
  })]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The lighthouse top at Watchet Harbour: the beacon of vision, the light of reason, and a lifelong delight in philosophy.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50e6edde","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1sp1.vue
// module id = 78
// module chunks = 0